// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ModalComponent.module.css */
.ModalComponent_modal__13QAl {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  overflow: visible;
}
.ModalComponent_modalWrapper__-GM0f {
  background-color: white;
  max-height: 90vh;
  padding: 24px;
  width: auto;

  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
  z-index: 1050;

}
.ModalComponent_modalWrapper__-GM0f > div {
  margin-bottom: 24px;
}
.ModalComponent_header__TzFDX,
.ModalComponent_footer__SWCQi {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.ModalComponent_button__9qQas {
  font-size: 16px;
  font-weight: 500;
  padding: 9px 16px;
  border-radius: 12px;
  color: #678aa1;
  background-color: #fff;
}
.ModalComponent_button__9qQas.ModalComponent_active__1G3Wt {
  color: #fff;
  background-color: #f40101;
}
.ModalComponent_button__9qQas.ModalComponent_green__X568x {
  background-color: #55bbeb !important;
}
.ModalComponent_content__X9w0H {
  color: #364954;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ModalComponent_title__l3ufk {
  margin-bottom: 8px;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./src/shared/Ui/ModalComponent/ModalComponent.module.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,WAAW;;EAEX,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;;AAEf;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* ModalComponent.module.css */\n.modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1001;\n  overflow: visible;\n}\n.modalWrapper {\n  background-color: white;\n  max-height: 90vh;\n  padding: 24px;\n  width: auto;\n\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);\n  z-index: 1050;\n\n}\n.modalWrapper > div {\n  margin-bottom: 24px;\n}\n.header,\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n.button {\n  font-size: 16px;\n  font-weight: 500;\n  padding: 9px 16px;\n  border-radius: 12px;\n  color: #678aa1;\n  background-color: #fff;\n}\n.button.active {\n  color: #fff;\n  background-color: #f40101;\n}\n.button.green {\n  background-color: #55bbeb !important;\n}\n.content {\n  color: #364954;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.title {\n  margin-bottom: 8px;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ModalComponent_modal__13QAl`,
	"modalWrapper": `ModalComponent_modalWrapper__-GM0f`,
	"header": `ModalComponent_header__TzFDX`,
	"footer": `ModalComponent_footer__SWCQi`,
	"button": `ModalComponent_button__9qQas`,
	"active": `ModalComponent_active__1G3Wt`,
	"green": `ModalComponent_green__X568x`,
	"content": `ModalComponent_content__X9w0H`,
	"title": `ModalComponent_title__l3ufk`
};
export default ___CSS_LOADER_EXPORT___;
